import React, { useEffect, useState } from 'react';
import { Row, Col, Table  } from "react-bootstrap";
import { toast } from 'react-toastify';
import Select from 'react-select';

const EstBecadosDetail = (props) => {

    let nombre = (n1, n2, a1, a2) => {
        let nombre2 = "";
        let apellido2 = "";
        if (n2 !== null) nombre2 = n2;
        if (a2 !== null) apellido2 = a2;
        return `${n1} ${nombre2} ${a1} ${apellido2}`;
    }

    let tipoBeca = (tipo) => {
        switch (tipo) {
            case "1": return "BECA COMPLETA"
            case "2": return "MEDIA BECA"
            case "3": return "BECA TRABAJO"
            default : return "BECA COMPLETA"
        }
    }

    const styles = {
        padding: 5, fontSize: 12
    }

    return (
        <React.Fragment>
            <tr>
                <td width="20px" style={styles} align = "center"><strong>{props.num}</strong></td>
                <td style={styles}>
                    <strong className = 'text-danger'>{`${props.data.nacionalidad} ${props.data.ci}`}</strong>
                    <div>{nombre(props.data.nombre_1, props.data.nombre_2, props.data.apellido_1, props.data.apellido_2)}</div>
                    {/* console.log(props.data) */}
                </td>
                <td style={styles} align = "center">{props.data.carrera_name}</td>
                <td style={styles} align = "center">
                    {tipoBeca(props.data.tipo_beca)}
                    <div className = 'text-danger'><strong>{props.data.beca_uc} U.C.</strong></div>
                </td>
                <td style={styles}></td>
            </tr>
        </React.Fragment>
    )
}

export default EstBecadosDetail;


// WEBPACK FOOTER //
// ./src/views/Bienestar/EstBecadosDetail.jsx